import { RecruiterDashboard } from "@components/ui/dashboard/ApplicantReview";
import { useEffect, useState } from "react";
import { Alert, Box, Typography } from "@mui/material";
import { HEADER_HEIGHT } from "@services/constants/header";
import { useSearchParams } from "react-router-dom";
import verifyApplicantBelongsToRecruiterOffer from "@services/api/recruiter/verifyApplicantBelongsToRecruiterOffer";
import { Loading } from "@components/common/Loading";
import { useLanguage } from "../../../contexts/LanguageContext";
import translations from "./index.translations.json";
import axios from "axios";
import { getByOfferBuilderId } from "@services/api/offer/getByOfferBuilderId/getByOfferBuilderId";

type SupportedLanguage = keyof typeof translations;

const DashboardOfferApplicantPage = () => {
    const { language } = useLanguage();
    const content = translations[language as SupportedLanguage] || translations.en;

    const [searchParams] = useSearchParams();

    const applicantEmail = searchParams.get("e"); // "1485"
    const offerBuilderId = searchParams.get("o"); // "1449"

    const [selectedCandidate, setSelectedCandidate] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [offer, setOffer] = useState<any>(null);

    useEffect(() => {
        let isActive = true;

        const handleVerifyApplicantBelongsToRecruiterOffer = async () => {
            if (!applicantEmail || !offerBuilderId) {
                setLoading(false);
                return;
            }

            setLoading(true);
            setErrorMessage(null);
            try {
                const offer = await getByOfferBuilderId({ id: Number(offerBuilderId)});
                const response = await verifyApplicantBelongsToRecruiterOffer(applicantEmail, parseInt(offer?.data?.id, 10));
                
                if (isActive) {
                    setOffer(offer?.data || null);
                    setSelectedCandidate(response?.data?.applicant || null);
                }
            } catch (error: unknown) {
                if (isActive) {
                    const responseMessage = axios.isAxiosError<{ message?: string }>(error)
                        ? error.response?.data?.message
                        : undefined;
                    setErrorMessage(responseMessage || (error instanceof Error ? error.message : ""));
                }
            } finally {
                if (isActive) {
                    setLoading(false);
                }
            }
        };

        handleVerifyApplicantBelongsToRecruiterOffer();
        return () => {
            isActive = false;
        };
    }, [applicantEmail, offerBuilderId]);

    if (!applicantEmail || !offerBuilderId) {
        return <></>;
    }

    return <Box sx={{ mt: HEADER_HEIGHT }}>
        {loading && <Loading />}
        {!loading && errorMessage !== null && (
            <Alert severity="error" sx={{ mx: 3, mt: 3 }}>
                {errorMessage || content.verificationError}
            </Alert>
        )}
        {!loading && errorMessage === null && selectedCandidate?.id && (
            <RecruiterDashboard
                applicantStatus={selectedCandidate?.status}
                offerId={parseInt(offer?.id, 10)}
                selectedCandidateId={selectedCandidate?.id}
            />
        )}
        {!loading && errorMessage === null && !selectedCandidate?.id && (
            <Box>
                <Typography sx={{ color: "#fff" }}>{content.noApplicantFound}</Typography>
            </Box>
        )}
    </Box>
}

export default DashboardOfferApplicantPage;